var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// react
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
// models
import { FieldType, ReferralFormType } from '@karehero/models';
// components
import { Card, Title } from "../../atoms";
import { createFieldHelper } from "../EditorFields/fieldHelper";
import { EditorFields } from "../EditorFields/EditorFields";
const sjpGdprFields = createFieldHelper({
    gdprSelections: {
        label: '',
        ariaLabel: 'gdpr-selection',
        field: {
            type: FieldType.MultiSelectBox,
            variant: 'default',
            options: [
                {
                    value: 'communication-consent',
                    label: 'I have received consent from the referred client to receive communications from KareHero.',
                },
                {
                    value: 'data-share-consent',
                    label: 'I have received consent from the referred client that they would like KareHero to share relevant information about their care needs with me.',
                },
            ],
        },
    },
});
const ifaGdprFields = createFieldHelper({
    gdprSelections: {
        label: '',
        ariaLabel: 'gdpr-selection',
        field: {
            type: FieldType.MultiSelectBox,
            variant: 'default',
            options: [
                {
                    value: 'communication-consent-ifa',
                    label: 'I have received consent from the referred client to receive communications from KareHero.',
                },
                {
                    value: 'data-share-consent-ifa',
                    label: 'I have received consent from the referred client that they would like KareHero to share relevant information about their care needs with me.',
                },
            ],
        },
    },
});
const SjpGdprConsent = ({ value, setValue }) => {
    return (_jsxs(Wrapper, { children: [_jsx(Title, Object.assign({ isNoMargin: true }, { children: "GDPR notice and consent" })), _jsx(EditorFields, { fields: sjpGdprFields, value: value, onChange: setValue }), _jsxs(Description, { children: ["For more information on our privacy practices and how we are committed to protecting and respecting your privacy, please review our", ' ', _jsx(StyledInternalLink, Object.assign({ to: `https://www.karehero.com/privacy-policy`, target: '_blank', rel: 'noopener noreferrer' }, { children: 'Privacy Policy' })), "."] }), _jsx(Description, { children: "By submitting you consent to allow KareHero to store and process the personal information provided to deliver the requested service." })] }));
};
const IfaGdprConsent = ({ value, setValue }) => {
    return (_jsx(Wrapper, { children: _jsx(GdprContainer, { children: _jsx(Card, Object.assign({ color: 'yellow', isBordered: false, isPaddingSm: true }, { children: _jsxs(GdprPanel, { children: [_jsx(SubTitle, { children: "GDPR and Consent" }), _jsxs(Description, { children: ["We are committed to protecting and respecting your privacy. You can read more about our Privacy Policy", ' ', _jsx(StyledInternalLink, Object.assign({ to: `https://www.karehero.com/privacy-policy`, target: '_blank', rel: 'noopener noreferrer' }, { children: "here" })), "."] }), _jsx(EditorFields, { fields: ifaGdprFields, value: value, onChange: setValue })] }) }), 'fee-description') }) }));
};
export const GdprConsent = (_a) => {
    var { formType } = _a, props = __rest(_a, ["formType"]);
    if (formType === ReferralFormType.SjpIFA) {
        return _jsx(SjpGdprConsent, Object.assign({ formType: formType }, props));
    }
    return _jsx(IfaGdprConsent, Object.assign({ formType: formType }, props));
};
// styles
const GdprContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing[24]};
  ${(props) => props.theme.breakpoint.md(css `
      flex-direction: row;
      align-items: stretch;
    `)}
`;
const SubTitle = styled.div `
  font: ${(props) => props.theme.typography.heading['2xl']};
  color: ${(props) => props.theme.color.neutral[100]};
  text-align: left;
`;
const Description = styled.div `
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[100]};
  text-align: left;
`;
const GdprPanel = styled.div `
  display: flex;
  flex-direction: column;
  min-width: 200px;
  gap: ${(props) => props.theme.spacing[8]};
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => props.theme.spacing[16]};
`;
const StyledInternalLink = styled(Link) `
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[100]};
  text-decoration: underline;
`;
GdprConsent.displayName = 'GdprConsent';
export default GdprConsent;
